import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    user: {},
    status: '',
  },
  reducers: {
    getUserPending: (state) => {
      state.status = 'pending';
    },
    getUserSuccess: (state, action) => {
      state.user = action.payload;
      state.status = 'success';
    },
    getUserError: (state) => {
      state.status = 'error';
    },
  },
});

export const { getUserSuccess, getUserError, getUserPending } = userSlice.actions;
export default userSlice.reducer;
